import React from 'react';

const FlagSd = props => (
  <svg viewBox="0 0 12 6" {...props}>
    <path d="M0 0h12v6H0z" />
    <path fill="#FFF" d="M0 0h12v4H0z" />
    <path fill="#D21034" d="M0 0h12v2H0z" />
    <path fill="#007229" d="M0 0l4 3-4 3z" />
  </svg>
);

export default FlagSd;
